import React from 'react';
import { Box, Button, Grid, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CollectionMobileDrawer } from './CollectionMobileDrawer';
import DehazeIcon from '@mui/icons-material/Dehaze';
import SearchIcon from '@mui/icons-material/Search';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import useMobileMenu from '../../../../../hooks/useMobileMenu';
import { LogoWrapperQuotation } from '../../../../shared/logos/LogoWrapperQuotation';
import { QuotationMobileDrawer } from './QuotationMobileDrawer';

const MenuContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
}));

const DashboardContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
}));

export const HeaderMobile = () => {
    const { t } = useTranslation();
    const mobileMenu = useMobileMenu();

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs>
                    <MenuContent>
                        <Button onClick={() => mobileMenu.showMainMenu(true)}>
                            <DehazeIcon color={'primary'} />
                        </Button>
                        <Button>
                            <SearchIcon color={'primary'} />
                        </Button>
                    </MenuContent>
                </Grid>
                <Grid item xs>
                    <LogoWrapperQuotation />
                </Grid>
                <Grid item xs>
                    <DashboardContent>
                        <Button>
                            <InsertDriveFileOutlinedIcon
                                color={'primary'}
                                onClick={() =>
                                    mobileMenu.showQuotationMenu(true)
                                }
                            />
                        </Button>
                    </DashboardContent>
                </Grid>
            </Grid>
            <CollectionMobileDrawer />
            <QuotationMobileDrawer />
        </>
    );
};
